export default "__VITE_ASSET__DZUayOoR__"